import React, { type FC } from "react";
import EllipsesMenuNutritionDialog from "./EllipsesMenuNutritionDialog";
import { Meal } from "@/app/nutrition/meal.enum";
import { Option } from "@/app/nutrition/option.enum";

export type SuplementationListItemProps = {
  isLoading?: boolean;
  suplementation?: any;
  onSetSuplementation?: (suplementation: any, meal: Meal) => void;
};

export const SuplementationListItem: FC<SuplementationListItemProps> = ({
  suplementation,
  onSetSuplementation,
}) => {
  return (
    <li
      key={suplementation.id}
      className="flex items-center justify-between border borded-gray-300 rounded-md"
    >
      <div className="min-w-0 p-4">
        <div className="flex items-start gap-x-3">
          <p className="text-sm font-semibold leading-6 text-gray-900">
            {suplementation.product}
          </p>
        </div>
      </div>
      <div className="flex flex-none items-center gap-x-4">
        <EllipsesMenuNutritionDialog
          onBreakFast={() =>
            onSetSuplementation(suplementation, Meal.Breakfast)
          }
          onMediaMana={() => onSetSuplementation(suplementation, Meal.Lunch)}
          onLunch={() => onSetSuplementation(suplementation, Meal.Meal)}
          onSnack={() => onSetSuplementation(suplementation, Meal.Snack)}
          onDinner={() => onSetSuplementation(suplementation, Meal.Dinner)}
          onPoscena={() => onSetSuplementation(suplementation, Meal.Redinner)}
        />
      </div>
    </li>
  );
};
